import React, { useState } from 'react'
import { Button, Card, Col, Container, Form, Pagination, Row, Table } from 'react-bootstrap'
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'
import { Workbook } from 'exceljs'
import ManagePackageService from '../services/ManagePackageService';
import { isObjectValid } from '../common/utils/validate';
import SweetAlert2 from 'react-sweetalert2';
import Loading from '../components/loading/Loading';
import { useNavigate } from 'react-router-dom';


const provicnes = ["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พังงา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "พะเยา", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยะลา", "ยโสธร", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสงคราม", "สมุทรสาคร", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อุดรธานี", "อุทัยธานี", "อุตรดิตถ์", "อุบลราชธานี", "อำนาจเจริญ"]


function SearchUserPackage() {

    const navigate = useNavigate()

    const [dataUserPackage, setDataUserPackage] = useState({})

    const [dataInput, setDataInput] = useState({
        province: '',
        corunty: 'ไทย'
    })

    const [searchCondition, setSearchCondition] = useState({
        province: '',
        corunty: 'ไทย'
    })

    const [isLoading, setIsLoading] = useState(false)
    const [swalProps, setSwalProps] = useState({});



    return (
        <div className='home-body font-link '>

            <Container>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ระบุเงื่อนไขการค้นหา</label>

                                <Row className='mt-4' style={{ alignItems: 'center' }}>
                                    <Col xs={2}>
                                        <label>ประเทศ</label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select
                                            defaultValue={dataInput.corunty}

                                            onChange={(e) => {

                                                // alert(e.target.value)
                                            }}
                                        >
                                            <option value="ไทย">ไทย</option>

                                        </Form.Select>
                                    </Col>

                                    <Col xs={2}>
                                        <label>จังหวัด</label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select
                                            defaultValue={dataInput.province}

                                            onChange={(e) => {

                                                setDataInput(prevState => ({
                                                    ...prevState, province: e.target.value
                                                }))
                                            }}
                                        >
                                            <option selected={dataInput.province === '' ? true : false}>กรุณาเลือก</option>
                                            {provicnes.map(item => {
                                                return <option value={item}>{item}</option>
                                            })}

                                        </Form.Select>
                                    </Col>



                                </Row>


                                <Row className='mt-4'>
                                    <div style={{ flexDirection: 'row' }}>

                                        <Button variant="primary" onClick={(e) => {

                                            onSearch(e)

                                        }}>Search</Button>


                                        <Button style={{ marginLeft: 10 }} variant="outline-secondary" onClick={() => {
                                            onReset()
                                        }}>Reset</Button>

                                    </div>

                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {isObjectValid(dataUserPackage) &&
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>

                                    <Row>
                                        <Col xs={12}>
                                            <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >จำนวนสมาชิก</label>

                                        </Col>

                                    </Row>

                                    <Row className='mt-4'>


                                        {/* <label>จำนวนทั้งหมดผู้ใช้ทั้งหมด 1000 </label> */}
                                        <Col>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Special From</th>
                                                        <th>จำนวน (คน)</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {dataUserPackage.plusFarmItems.map((item, index) => {

                                                        return (
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td>{item.packageName}</td>
                                                                <td>{item.total}</td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>



                                    <Row>
                                        <Col xs={12}>
                                            <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >เพคเกจที่ทำการเพิ่ม</label>

                                        </Col>

                                    </Row>

                                    <Row className='mt-4'>


                                        {/* <label>จำนวนทั้งหมดผู้ใช้ทั้งหมด 1000 </label> */}
                                        <Col>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Special From</th>
                                                        <th>จำนวน (คน)</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {dataUserPackage.topUpPackageItems.map((item, index) => {

                                                        return (
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td>{item.packageName}</td>
                                                                <td>{item.total}</td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                }
            </Container>

            <Loading isShow={isLoading} />

            <SweetAlert2 {...swalProps}

                didClose={() => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}

                onConfirm={result => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}


            />

        </div>
    )

    function onReset() {


        setDataUserPackage({})


        setDataInput({
            province: '',
            corunty: 'ไทย'
        })


    }


    async function onSearch() {

        // if (dataInput.corunty !== '' && dataInput.province !== '') {

            let params = new URLSearchParams()

            params.append('corunty', dataInput.corunty)
            params.append('province', dataInput.province === 'กรุณาเลือก' ? '' : dataInput.province)

            setIsLoading(true)
            ManagePackageService.searchUserPackage(params).then(result => {
                setIsLoading(false)

                if (result.status === 200) {
                    setSearchCondition({
                        province: dataInput.province,
                        corunty: dataInput.corunty
                    })
                    setDataUserPackage(result.data)
              
                }

            }).catch(err => {
                setIsLoading(false)
    
    
                if (err.status === 401) {
                    navigate('/login')
                }
    
            })


        // }
        // else {
        //     setSwalProps({
        //         show: true,
        //         icon: 'info',
        //         html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        //         showConfirmButton: true,
        //         confirmButtonColor: '#0d6efd',
        //         confirmButtonText: 'OK',
        //     });
        // }
    }


}

export default SearchUserPackage